import { LanguageEnum } from "../enum/language-enum";

export const PT = { id: 0, name: LanguageEnum.PT_BR, class: 'circle br', disabled: true };
export const EN = { id: 1, name: LanguageEnum.EN_US, class: 'circle eua', disabled: false };
export const ES = { id: 2, name: LanguageEnum.ES_ES, class: 'circle esp', disabled: false };


export const LANGUAGE_LIST = [PT, EN, ES]